module.exports = __webpack_public_path__ + "img/dfh.df60753c.png";